import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/superadmin/themes")({
  // Component moved to superadmin.themes.lazy.tsx for code splitting
});
